import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { InventoryService } from '../../modules/shared/services/inventory/inventory.service';

@Component({
  selector: 'formly-inventory-item-search',
  template: `
    <div class="form-group">
      <label>Inventory Item: *</label>
      <p-autoComplete
        [suggestions]="results"
        (completeMethod)="getSearchResults($event)"
        [formControl]="formControl"
        [formlyAttributes]="field"
        field="name"
        [forceSelection]="true"
        [placeholder]="'Search inventory by name'"
        [showEmptyMessage]="true"
        [emptyMessage]="'No inventory item found. Try typing full name e.g. Kovaltry'"
        [required]="true"
      ></p-autoComplete>
    </div>
  `,
})
export class InventoryItemSearchInputFieldComponent extends FieldType {

  subscriptions = new Subscription();
  results: any[];
  rows = 100;

  defaultPagination = {
    page: 0,
    pageSize: this.rows,
    searchParam: null,
  };

  constructor(
    private inventoryService: InventoryService
  ) {
    super();
  }

  getSearchResults(event): void {
    let searchText = event.query;
    if (searchText) {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: searchText,
      };
    }
    this.getPaginatedInventoryItems();
  }

  getPaginatedInventoryItems(): void {
      this.subscriptions.add(
        this.inventoryService
    .getPaginatedInventoryItems(this.defaultPagination)
          .subscribe({
            next: (res) => {
              this.results = res.result;
            }
          })
      );
  }
}
